import axios from "axios";

const server = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true
})

export class AsapFetchAPI {

    //Function to get asap fare order 
    static async getAsapFareOrder(token, data){
        const res = await server(`/fare/asap`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,
            data: data,
        });
        return res;
    }

    //Function to register the asap order
    static async registerAsapOrder(token, data){
        const res = await server(`/asap`, {
            method: "post",
            headers: token ? { 'x-access-token': token } : undefined,
            data: data,
        });
        return res;
    }
    //Function to get asap order status
    static async getAsapOrderLogStatus(token, branchoffice_id, rider_order_id){
        const res = await server(`/log/asap?branchoffice_id=${branchoffice_id}&rider_order_id=${rider_order_id}`, {
            method: "get",
            headers: token ? { 'x-access-token': token } : undefined,
        });
        return res;
    }
}